import React, { useEffect, useState } from 'react';
import { FaCheckCircle, FaTimesCircle } from "react-icons/fa";
import SummaryApi from '../common';
import UploadBrand from '../components/UploadBrand';
import AdminBrandCard from '../components/AdminBrandCard';
import { toast } from 'react-toastify';

const AllBrands = () => {

  const [openUploadBrand, setOpenUploadBrand] = useState(false);
  const [allBrand, setAllBrand] = useState([]);

  const fetchAllBrand = async () => {
    try {
      const response = await fetch(
        SummaryApi.adminBrand.url,
        {
          headers: {
            Authorization: 'Bearer oakyaecom_no_units_916',
            'Content-Type': 'application/json',
          },
        }
      );

      if (!response.ok) {
        throw new Error('Failed to fetch brands');
      }

      const dataResponse = await response.json();

      const reversedBrands = (dataResponse?.data || []).reverse();

      setAllBrand(reversedBrands);

    } catch (error) {
      console.error(error);
      toast.error(`Failed to fetch brands: ${error.message}`);
    }
  };

  useEffect(() => {
    fetchAllBrand();
  }, []);

  return (
    <div className="min-h-screen bg-gray-50">

      {/* Header */}
      <div className='bg-white py-3 px-4 flex flex-col sm:flex-row justify-between items-center shadow-sm'>

        <h2 className='font-bold text-xl text-gray-800'>
          All Brands
        </h2>

        <div className='flex items-center gap-6 mt-3 sm:mt-0'>

          <div className='flex items-center text-sm text-gray-600'>

            <span>Active</span>
            <FaCheckCircle className='mx-2 text-lg text-green-600' />

            <span className='ml-3'>
              Inactive
            </span>

            <FaTimesCircle className='mx-2 text-lg text-red-600' />

          </div>

          <button
            className='border-2 border-red-600 text-red-600 hover:bg-red-600 hover:text-white transition-all py-1.5 px-4 rounded-full font-medium'
            onClick={() => setOpenUploadBrand(true)}
          >
            Add Brand
          </button>

        </div>

      </div>

      {/* Empty State */}
      {allBrand.length === 0 ? (

        <div className="flex flex-col items-center justify-center py-20 px-4 text-center">

          <h3 className="text-xl font-semibold text-gray-700 mb-2">
            No Brands Added Yet
          </h3>

          <p className="text-gray-500 mb-6 max-w-md">
            Start building your brand collection by adding your first brand.
          </p>

          <button
            className='bg-red-600 text-white hover:bg-red-700 transition-all py-2 px-6 rounded-full font-medium shadow-sm'
            onClick={() => setOpenUploadBrand(true)}
          >
            Add New Brand
          </button>

        </div>

      ) : (

        <div className='grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-5 p-6'>

          {allBrand.map((brand, index) => (
            <AdminBrandCard
              key={brand.brand_id || index}
              data={brand}
              serialNumber={index + 1}
              fetchdata={fetchAllBrand}
            />
          ))}

        </div>

      )}

      {openUploadBrand && (
        <UploadBrand
          onClose={() => setOpenUploadBrand(false)}
          fetchdata={fetchAllBrand}
        />
      )}

    </div>
  );
};

export default AllBrands;